export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Drivers',
        route: 'drivers',
        icon: 'FileIcon',
      },
      {
        title: 'Zones/Services',
        route: 'zones-services',
        icon: 'SettingsIcon',
      },
    ],
  },
]
